/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemResponseSchema } from './itemResponseSchema';

export const paginationDocumentItemResponseSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(itemResponseSchema);
  },
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
